import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import * as base from './base.jsx';
import React from 'react';

class Form extends base.BaseComponent {
  constructor(props) {
    super(props);
    this.fields = [];
  }

  getDefaultState() {
    return {
      className: this.props.className || "form",
      method: this.props.method || "POST",
      action: this.props.action || ".",
      fetchAPI: this.props.fetchAPI,
      notifications: [],
      data: this.props.initialData || {},
      hasFetchedData: false,
      validationErrors: {},
      hasStartedValidating: false,
      validationFailedMessage: "Something went wrong, please check the error messages below"
    }
  }
  
  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.initialData && JSON.stringify(this.props.initialData) != JSON.stringify(newProps.initialData)) {
      this.setState({
        data: newProps.initialData
      });
    }

    if (newProps.action && this.props.action != newProps.action) {
      this.setState({
        action: newProps.action
      });
    }
  }

  getValueForField(name) {
    return this.state.data[name];
  }

  isFormField(component) {
    if (component == undefined || component == null || component.type == undefined || typeof(component.type) != "function") {
      return false;
    }

    if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
      // IE 10 fails at this. This is a pretty bad way of detecting a form field
      // but I can't really find a better way
      var p = Object.getPrototypeOf(component);
      // had to remove p._isReactElement because it returned undefined when it was
      if (p && component.type.toString().indexOf("Field") != -1) {
        return true;
      }
    } else {
      if (component.type == undefined || typeof(component.type) != "function") {
        return false;
      }

      var t = component.type;
      while (t != null) {
        t = Object.getPrototypeOf(t);

        if (t == FormField) {
          return true;
        }
      }

      return false;
    }
  }

  validate() {
    var validationErrors = {};

    for (var field of this.fields) {
      var fieldErrors = field.validate();

      if (fieldErrors) {
        if (Array.isArray(fieldErrors)) {
          if (fieldErrors.length > 0) {
            validationErrors[field.props.name] = fieldErrors
          }
        } else {
          // Allow complex objects to set validation errors for other keys
          $.extend(validationErrors, fieldErrors);
        }
      }
    }

    var hasValidationErrors = (Object.keys(validationErrors).length > 0)
    var updatedState = {
      validationErrors: validationErrors,
      hasStartedValidating: true
    };

    this.setState(updatedState);

    return !hasValidationErrors
  }

  // Form successfully posted
  onSuccess(data) {
  }

  // API responded with a non 200 response code
  onFailure(data) {
  }

  // Network or unexpected error
  onError(jqXHR, textStatus, errorThrown) {
  }

  addNotification(style, message) {
    var key = 1;
    if (this.state.notifications.length > 0) {
      key = this.state.notifications[this.state.notifications.length-1].key + 1;
    }
    var newNotification = {
      style:style,
      message:message,
      key: key
    }
    this.state.notifications.push(newNotification);
    this.setState({
      notifications: this.state.notifications
    });
  }

  onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.validate()) {
      this.setState({
        notifications: []
      });

      var loading = null;
      if (this.refs.form) {
        loading = Utils.loading($(this.refs.form));
      }

      $.ajax({
        url: this.state.action,
        method: this.state.method,
        dataType: "json",
        data: JSON.stringify(this.state.data),
        contentType: "application/json; charset=utf-8",
      }).done((data, textStatus) => {
        loading.remove();
        if (data.status >= 200 && data.status < 300) {
          // Success
          if (data.message) {
              if (this.props.showSuccessNotification) {
                  this.addNotification('success', data.message);
              }
            this.setState({
              hasStartedValidating: false, // Once we submit successfully, stop insta-validating
            });
          }

          if (this.props.onSuccess) {
            this.props.onSuccess(data.data);
          }

          this.onSuccess(data);
        }
        else {
          if (data.message) {
            this.addNotification('danger', data.message);
          }

          if (data.data && data.data.errors) {
            this.setState({
              validationErrors: data.data.errors
            });
          }

          if (this.props.onFailure) {
            this.props.onFailure(data);
          }

          this.onFailure(data);
        }
      }).fail((jqXHR, textStatus, errorThrown) => {
        loading.remove();
        var errorMessage = Utils.errorMessage(textStatus, errorThrown);
        this.addNotification('danger', errorMessage);
        this.onError(null);
      });
    }
  }

  onChildChange(name, value) {
    this.setState(currentState => {
      if (!currentState.data) {
        currentState.data = {};
      }

      var namePieces = name.split('.');
      var data = currentState.data;
      for (var i = 0; i < namePieces.length - 1; i++) {
        data = data[namePieces[i]];
      }

      data[namePieces[namePieces.length - 1]] = value;
      return currentState;
    })

    this.revalidateIfStarted();
  }

  revalidateIfStarted() {
    if (this.state.hasStartedValidating) {
      setTimeout(() => this.validate(), 0);
    }
  }

  fieldAdded(field) {
    this.fields.push(field);
  }

  fieldRemoved(field) {
    this.fields = this.fields.filter(e => e != field);
  }

  renderHeader() {
    return null;
  }

  alertDismiss(key) {
    for (var i = 0; i < this.state.notifications.length; i++) {
      if (this.state.notifications[i].key == key) {
        this.state.notifications.splice(i, 1);
        break;
      }
    }

    this.setState({
      notifications:this.state.notifications
    });
  }

  renderNotifications() {
    return <div className="notifications-wrapper">
    {
      this.state.notifications.map((notification) => {
        return <waffle.misc.Alert
               message={notification.message}
               style={notification.style}
               onDismiss={this.alertDismiss.bind(this, notification.key)}
               key={"notification-"+notification.key} />
      })
    }
    </div>
  }

  getFields() {
    return <fieldset>
      { this.props.children }
    </fieldset>
  }

  attachField(field) {
    var value = field.props.value;
    if (!value) {
      var namePieces = field.props.name.split('.');
      var data = this.state.data;
      for (let name of namePieces) {
        if (data) {
          data = data[name];
        }
      }
      value = data;
    }

    let newProps = {
      form: this,
      value: value,
      validationErrors: this.state.validationErrors[field.props.name],
      key: field.props.id || field.props.name
    }

    if (field.props.required) {
      newProps.validators = (field.props.validators || []).concat([new RequiredValidator()])
    }

    return React.cloneElement(field, newProps)
  }

  attachFields(parent) {
    if (parent && parent.props) {
      return React.cloneElement(
        parent,
        {
          children: React.Children.map(parent.props.children, (field) => {
            if (this.isFormField(field)) {
              return this.attachField(field);
            }
            else if (field) {
              // If this is not a form field, we should recursively check for
              // nested fields
              return this.attachFields(field);
            }
          })
        }
      )
    } else {
      return parent;
    }
  }

  render() {
    return <form ref="form" onSubmit={this.onSubmit.bind(this)} className={this.state.className} action={this.state.action} method={this.state.method}>
      { this.renderHeader() }
      { this.renderNotifications() }
      <div className="fieldset">
        { this.attachFields(this.getFields()) }
      </div>
    </form>
  }

  fetchData() {
    if (this.state.fetchAPI) {
      var loading = null;
      if (this.refs.form) {
        loading = Utils.loading($(this.refs.form));
      }

      $.ajax({
        url: this.state.fetchAPI,
        method: "GET",
        dataType: "json"
      }).done((data, textStatus) => {
        loading.remove();

        if (data.status >= 200 && data.status < 300) {
          console.log("Fetched API", data);

          var innerData = data.data[Object.keys(data.data)[0]];
          if (this.props.dataPath) {
            innerData = waffle.utils.traverse(data.data, this.props.dataPath);
          }

          this.setState({
            data: innerData
          });
        }
        else {
          if (data.message) {
            this.setState({
              notifications: [{
                style: "danger",
                message: data.message
              }]
            });
          }
        }
      }).fail((jqXHR, textStatus, errorThrown) => {
        loading.remove();
        var errorMessage = Utils.errorMessage(textStatus, errorThrown);
        this.setState({
          notifications: [{
            style: "danger",
            message: errorMessage,
          }]
        });
      });
    }
  }

  componentDidMount() {
    if (this.state.fetchAPI) {
      // We must fetch our data
      this.fetchData();
    }
  }
}

Form.defaultProps = {
 showSuccessNotification: true
}

class FormField extends base.BaseComponent {
  constructor(props) {
    super(props);

  }

  componentDidMount() {
    if (this.props.form) {
      this.props.form.fieldAdded(this);
    }
  }

  componentWillUnmount() {
    if (this.props.form) {
      this.props.form.fieldRemoved(this);
    }
  }

  validate() {
    var validationErrors = [];

    if (this.props.validators) {
      for (let validator of this.props.validators) {
        var message = validator.validate(this.props.value);
        if (message) {
          validationErrors.push(message);
        }
      }
    }

    return validationErrors;
  }

  getDefaultState() {
    var label = this.props.label;
    if (!label && this.props.name) {
      label = this.props.name.underscore().humanize()
    }
    return {
      className: this.props.className || "form-field",
      label: label,
      focused: false
    }
  }

  renderHelp() {
    if (this.props.validationErrors) {
      return <div className="help-block">
      <i className="icon-alert icon-error"></i>
        <div className="field-error">
          { this.props.validationErrors[0] }
        </div>
      </div>
    }
    else {
      return <div className="help-block">
        { this.props.description }
      </div>
    }
  }

  onChange(event) {
    this.props.form.onChildChange(
      this.props.name,
      event.target.value
    )

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  onFocus(event) {
    this.setState({
      "focused": true
    })
  }

  onBlur(event) {
    this.setState({
      "focused": false
    })
  }

  getDivClassName() {
    var className = this.state.className;
    if (this.state.focused) {
      className += " active";
    }
    if (this.props.validationErrors) {
      className += " with-error"
    }

    return className;
  }

  render() {
    return <div className={this.getDivClassName()}>
      <label htmlFor={this.props.name} style={this.props.labelStyle}>{this.state.label}</label>
      { this.renderInput() }
      <div className="help">
        { this.renderHelp()}
      </div>
    </div>
  }
}

class FormGroup extends base.BaseComponent {
  render() {
    return <div className="form-group">
      { this.props.children }
    </div>
  }
}

class SelectField extends FormField {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      asyncOptions: this.props.asyncOptions
    })
  }

  constructor(props) {
    super(props);

    this.asyncOptions = this.props.asyncOptions;
    this.data = {};

    if (this.props.api) {
      this.asyncOptions = (input, callback) => {

        // Add our search string
        var url = this.props.api;
        if (input) {
          if (url.indexOf("?") != -1) {
            url = url + "&search=" + encodeURIComponent(input);
          } else {
            url = url + "?search=" + encodeURIComponent(input);
          }
        }

        $.ajax({
          url: url,
          method: "GET",
          dataType: "json"
        }).done((data, textStatus) => {
          var d = undefined;
          var options = undefined;
          if (data.status === 200) {
            d = data.data;
            options = d[Object.keys(d)[0]].map(option => {
              var disabled = false;
              if (this.props.testDisabled) {
                disabled = this.props.testDisabled(option);
              }
              return {
                "value": option.uuid,
                "label": option.name,
                "disabled": disabled
              }
            });
            this.data = options;
          } else if (this.props.onError) {
            this.props.onError(data);
          }

          this.fullOptions = d[Object.keys(d)[0]];

          callback(options);
        }).fail((jqXHR, textStatus, errorThrown) => {
          this.data = {};
          callback([]);
        });
      }
    } else if (this.props.propertyGroup){
      this.asyncOptions = (input, callback) => {
        // Add our search string
        var url = "/api/api/common/v1/properties/" + this.props.propertyGroup + "?countryCode=all"
        if (input != this.props.value) {
          url = url + "&search=" + encodeURIComponent(input);
        }

        $.ajax({
          url: url,
          method: "GET",
          dataType: "json"
        }).done((data, textStatus) => {
          var d = data.data;
          var options = [];
          for (let property of data.data) {
            options.push({
              'value': property[0],
              'label': property[1]
            })
          }
          callback(null, {
            options: options,
            complete: true
          })
        }).fail((jqXHR, textStatus, errorThrown) => {
          callback(null, {
            options: [],
            complete: true
          });
        });
      }
    }
  }

  onChange(option) {
    // To retain backwards compatibility with older react-select which only passes in the option.value
    // Newer react-select passes the entire option
    const value = option.value;

    if (this.props.onChange) {
      // Forward both the value and the full element, e.g. {value, label} tuple to the listener if specified.
      this.props.onChange(value, option);
    } else {
      this.props.form.onChildChange(this.props.name, value);
    }

    if (this.props.onFullOptionChanged) {
      for(let option of this.fullOptions) {
        if (option.uuid === value) {
          this.props.onFullOptionChanged(option);
        }
      }
    }
  }

  renderInput() {
    if (this.props.selectInput) {
      // If we really want to customize everything in our select box we can
      // pass one in
      return this.props.selectInput;
    } else {
      var searchable = true;
      if (this.props.searchable != 'undefined') {
        searchable = this.props.searchable;
      }
      var clearable = true;
      if (this.props.clearable != 'undefined') {
        clearable = this.props.clearable;
      }
      if (this.props.asyncOptions === undefined && this.props.options !== undefined) {
          this.data = this.props.options;
          this.fullOptions = this.props.options;
      }

      const props = {
        name: this.props.name,
        inputValue: this.state.inputValue,
        onInputChange: inputValue => this.setState({ inputValue: inputValue }),
        onChange: this.onChange.bind(this),
        onFocus: this.onFocus.bind(this),
        onBlur: this.onBlur.bind(this),
        options: this.props.options,
        loadOptions: this.asyncOptions,
        placeholder: this.props.placeholder,
        searchable: searchable,
        disabled: this.props.disabled,
        clearable: clearable,
        // Workaround for bug https://github.com/JedWatson/react-select/issues/439
        cacheAsyncResults: false,
      }

      if (this.asyncOptions) {
        return <AsyncSelect {...props} />;
      } else {
        return <Select {...props} />;
      }
    }
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.refs.select) {
      Utils.doSelectize($(this.refs.select),
        this.onSelect.bind(this),
        this.onFocus.bind(this),
        this.onBlur.bind(this));
    }
  }
}

class CheckBoxField extends FormField {
    getDefaultState(){
      return $.extend(super.getDefaultState(), {
        className: "form-field checkbox-field"
      });
    }

    onClick (){
      this.props.form.onChildChange(
        this.props.name,
        !this.props.value
      )
    }


    render() {
      return <div className={this.getDivClassName()}>
        <div className="checkbox-label-wrapper">
          { this.renderInput() }
        <span>{this.props.label}</span>
        </div>
        <div className="help">
          { this.renderHelp()}
        </div>
      </div>
    }


    renderInput() {
      return <waffle.misc.CheckboxButton
                name={this.props.name}
                onClick={this.onClick.bind(this)}
                selected={this.props.value} >
        </waffle.misc.CheckboxButton>
    }
}

class InputField extends FormField {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      inputType: this.props.inputType || "text"
    });
  }

  renderInput() {
    return <input
      className={"form-control" || this.props.classname }
      placeholder={this.props.placeholder}
      name={this.props.name}
      type={this.props.inputType}
      value={this.props.value}
      disabled={this.props.readOnly ? true : false}
      onChange={this.props.readOnly ? undefined : this.onChange.bind(this)}
      onFocus={this.onFocus.bind(this)}
      title={this.props.title}
      onBlur={this.onBlur.bind(this)}>
    </input>
  }
}

class PasswordField extends InputField {
}
PasswordField.defaultProps = {
  inputType: "password"
};

class TextAreaField extends FormField {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    
    this.handleOnChange = this.handleOnChange.bind(this);
  }
  
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      inputType: this.props.inputType || "textarea",
      value: undefined
    });
  }
  
  handleOnChange(event) {
    this.onChange(event);
  }
  
  renderInput(){
    return <textarea
      onChange={this.handleOnChange}
      className={'form-control' || this.props.classname}
      placeholder={this.props.placeholder}
      name={this.props.name}
      id={this.props.id || this.props.name}
      onFocus={this.onFocus.bind(this)}
      rows={this.props.rows}
      cols={this.props.cols}
      title={this.props.title}>
      
  </textarea>
  }
}

// The base class for all validators
class Validator {
  validate(value) {
    return "Undefined validator"
  }
}


class RequiredValidator {
  constructor(emptyMessage) {
    this.emptyMessage = emptyMessage || "This field is required";
  }

  validate(value) {
    if (!value) {
      return this.emptyMessage;
    }

    return null;
  }
}

class EmailValidator {
  constructor(invalidMessage) {
    this.invalidMessage = invalidMessage || "Please enter a valid email address"
  }

  validate(value) {
    if (!value || value.length == 0) {
      return
    }

    if (value.length < 5) {
      return this.invalidMessage
    }

    if (value.lastIndexOf("@") == -1 || value.lastIndexOf(".") == -1) {
      return this.invalidMessage
    }

    var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

    if (!emailRegex.test(value)) {
      return this.invalidMessage
    }
  }
}

class MobileValidator {
  constructor(invalidMessage) {
    this.invalidMessage = invalidMessage || "Please enter a valid mobile number"
  }

  validate(value) {
    if (!value || value.length == 0) {
      return
    }

    var mobileRegex = /^[0-9\(\)+ ]{10,18}$/

    if (!mobileRegex.test(value)) {
      return this.invalidMessage
    }
  }
}

class EmailOrMobileValidator {
  constructor(invalidMessage) {
    this.invalidMessage = invalidMessage || "Please enter a valid email address or mobile number"
  }

  validate(value) {
    var mobileValidation = new MobileValidator().validate(value);
    if (!mobileValidation) {
      return
    }

    var emailValidation = new EmailValidator().validate(value);
    if (!emailValidation) {
      return
    }

    return this.invalidMessage
  }
}

class NumberValidator {
  constructor(allowDecimal = true, minimumValue = undefined, maximumValue = undefined, messages = {}) {
    this.allowDecimal = allowDecimal;
    this.minimumValue = minimumValue;
    this.maximumValue = maximumValue;
    this.messages = messages;
  }

  validate(value) {
    if (value) {
      var integerRegex = /^[\d-]+$/;
      if (!integerRegex.test(value)) {
        if (this.allowDecimal) {
          var decimalRegex = /^[\d\.-]+$/;

          if (!decimalRegex.test(value)) {
            return this.messages.notNumeric || "Only number values allowed";
          }
        }
        else {
          return this.messages.notNumeric || "Only integer values allowed";
        }
      }

      var parsed = parseFloat(value);

      if (this.minimumValue != undefined) {
        if (parsed < this.minimumValue) {
          return this.messages.belowMinimum || `Number must be > ${this.minimumValue}`;
        }
      }

      if (this.maximumValue != undefined) {
        if (parsed > this.maximumValue) {
          return this.messages.aboveMaximum || `Number must be < ${this.minimumValue}`;
        }
      }
    }
  }
}


module.exports = {
  Form: Form,
  FormField: FormField,
  FormGroup: FormGroup,
  SelectField: SelectField,
  CheckBoxField: CheckBoxField,
  InputField: InputField,
  TextAreaField: TextAreaField,
  PasswordField: PasswordField,
  Validator: Validator,
  RequiredValidator: RequiredValidator,
  EmailValidator: EmailValidator,
  MobileValidator: MobileValidator,
  EmailOrMobileValidator: EmailOrMobileValidator,
  NumberValidator: NumberValidator
}
